export class KafkaConnectProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "bootstrapServers",
            "baseName": "bootstrapServers",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaConnectProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
